export default function AdminReportsPage() {
  return <div>Reports management will render here after migration.</div>
}
